import type { ColumnDef } from "@tanstack/react-table";
import { ZonedDateTime } from "@/accounts-payable/common";
import type { ApEmail } from "@/accounts-payable/types";

export const receivedCol: ColumnDef<ApEmail> = {
  accessorKey: "received_at",
  header: "Received",
  meta: { size: "150px" },
  cell: ({ row }) => (
    <ZonedDateTime value={row.original.received_at} className="text-subtle" />
  ),
};
